import { useAnalytics } from '.';

export type SegmentAttributes = {
  destination_url?: string;
  entity_name?: string;
  item_copy?: string;
  item_level?: number;
  item_position?: number;
  l1_nav_copy?: string;
  l2_nav_copy?: string;
  link_copy?: string;
  link_position?: number;
  navigation_format?: string;
  section_name?: string;
  registration_cohort?: string;
  read_status?: string;
  notification_id?: string;
  notification_creation_timestamp?: string;
  slug?: string;
  campaign_id?: string;
  campaign_name?: string;
  template_id?: string;
  template_name?: string;
};

type useSegmentActionProps = {
  eventName: string;
  attributes: SegmentAttributes;
};

export const useSegmentInteraction = ({ eventName, attributes }: useSegmentActionProps) => {
  const { analytics, deployableName, deployableVersion } = useAnalytics();

  const segmentProps = {
    ...attributes,
    deployable_name: deployableName,
    deployable_version: deployableVersion,
  };

  return (overrideProps?: SegmentAttributes, callback?: () => void) => {
    if (analytics?.segmentInstance && typeof analytics.segmentInstance.track === 'function') {
      void analytics.segmentInstance
        .track(eventName, { ...segmentProps, ...overrideProps })
        .finally(() => {
          callback?.();
        });
    } else {
      void callback?.();
    }
  };
};
